const mobilePaperSx = {
	minWidth: '100vw',
	minHeight: '100vh',
	borderRadius: 0,
	overflow: 'hidden',
	boxShadow: 'none',
	top: '0px !important',
	left: '0px !important',
	position: 'fixed',
};

const desktopPaperSx = {
	mt: '64px',
	width: '260px',
};

export {mobilePaperSx, desktopPaperSx};
